import React, { ReactNode } from 'react';

// Define your data type here
export type ViewAndDownloadFileStatsTableData = {
  dataRoomMemberName: string;
  numberOfViews: number;
  numberOfDownloads: number;
};

// Define table columns
export const COLUMNS: Array<keyof ViewAndDownloadFileStatsTableData> = [
  'dataRoomMemberName',
  'numberOfViews',
  'numberOfDownloads',
];

// Define heading translations
export const HEADING_TRANSLATIONS: Partial<
  Record<typeof COLUMNS[number], string>
> = {
  dataRoomMemberName: 'member',
  numberOfViews: 'numberOfViews',
  numberOfDownloads: 'numberOfDownloads',
};

// Define sorting values (optional)
export const SORTING_VALUES: Partial<Record<typeof COLUMNS[number], string>> = {
  numberOfViews: 'numberOfViews',
  numberOfDownloads: 'numberOfDownloads',
};

// Define custom column sizes (optional)
export const CUSTOM_COL_SIZES: Partial<Record<typeof COLUMNS[number], number>> =
  {
    // Add your custom sizes here
    dataRoomMemberName: 220,
  };

type CellProps = {
  data: ViewAndDownloadFileStatsTableData;
};

const NameCell: React.FC<CellProps> = ({ data }) => {
  const { dataRoomMemberName } = data;

  return <div>{dataRoomMemberName}</div>;
};

const NumberOfViewsCell: React.FC<CellProps> = ({ data }) => {
  const { numberOfViews } = data;

  return <div>{numberOfViews}</div>;
};

const NumberOfDownloadsCell: React.FC<CellProps> = ({ data }) => {
  const { numberOfDownloads } = data;

  return <div>{numberOfDownloads}</div>;
};

export const BODY_CONTENT_GENERATE: Record<
  keyof ViewAndDownloadFileStatsTableData,
  (cellProps: CellProps) => ReactNode
> = {
  dataRoomMemberName: (cellProps: CellProps) => <NameCell {...cellProps} />,
  numberOfViews: (cellProps: CellProps) => <NumberOfViewsCell {...cellProps} />,
  numberOfDownloads: (cellProps: CellProps) => (
    <NumberOfDownloadsCell {...cellProps} />
  ),
};
